import ChargeHelper from 'features/Charge/chargeHelper';
import useCharge from 'features/Charge/useCharge';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import CustomDateRangePicker from 'general/components/Others/CustomDateRangePicker';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useMemo } from 'react';

DashboardChartFilterFields.propTypes = {
  draftFilter: PropTypes.object.isRequired,
  setDraftFilter: PropTypes.func.isRequired,
  selectedChargeStation: PropTypes.object,
  setSelectedChargeStation: PropTypes.func.isRequired,
  showDateRange: PropTypes.bool,
  dateDirection: PropTypes.string,
};

function DashboardChartFilterFields({
  draftFilter,
  setDraftFilter,
  selectedChargeStation,
  setSelectedChargeStation,
  showDateRange = true,
  dateDirection,
}) {
  const { managementObjectOptions } = useCharge();
  const managedBy = draftFilter?.managedBy ?? '';

  const dropdownChargeStationEl = useMemo(() => {
    return (
      <CustomDropdown2
        id="dashboard_station_filter"
        name="dashboard_station_filter"
        toggleElement={
          <button
            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${
              !managedBy ? 'disabled' : ''
            }`}
            type="button"
            disabled={!managedBy}
          >
            {selectedChargeStation?.name ?? 'Tất cả'}
          </button>
        }
        selectedValue={selectedChargeStation}
        disabled={!managedBy}
        dependItem={managedBy}
        dropdownMenuItems={[{ name: 'Trạm sạc', role: 'STATION' }]}
        subTitleType="stationCode"
        getSubItems={async (item) => {
          return ChargeHelper.API.requestGetChargeStationList(
            Utils.filterParams({
              page: item?.page || 0,
              limit: 10,
              q: item?.q || '',
              managedBy,
            })
          ).then((data) => {
            let values = data.chargeStations?.map((station) => ({
              id: station?.stationId,
              name: station?.name,
              item: station,
              stationCode: station?.stationCode,
            }));
            if (!Utils.isValid(item?.page) || _.toNumber(item?.page) === 0) {
              values = [
                {
                  id: null,
                  name: 'Tất cả',
                  item: null,
                  stationCode: '',
                },
              ].concat(values);
            }
            return {
              values: values,
              total: data.total,
            };
          });
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        onChange={(value) => {
          setSelectedChargeStation(value?.id ? value : null);
          setDraftFilter({
            ...draftFilter,
            stationId: value?.id ?? '',
          });
        }}
        isDropdownForm={true}
        titleSearchable={true}
        searchable={true}
        searchFormClassName="mx-3 my-1 search-form-border"
        ignoreConfirmClick={true}
        direction={dateDirection}
        defaultValue={{
          name: 'Trạm sạc',
          role: 'STATION',
        }}
      />
    );
  }, [draftFilter, managedBy, selectedChargeStation, setDraftFilter, setSelectedChargeStation, dateDirection]);

  return (
    <>
      <div className="col-12 pb-2 p-0">
        {UIHelper.buildFormLabel('Loại trạm sạc')}
        <KTBSDropdown
          name="dashboard_managedBy_filter"
          toggleElement={
            <button
              className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
              type="button"
            >
              {_.find(managementObjectOptions, (item) => item.value === managedBy)?.name ??
                'Tất cả trạm'}
            </button>
          }
          selectedValue={managedBy}
          dropdownMenuItems={[{ name: 'Tất cả trạm', value: '' }, ...managementObjectOptions]}
          dropdownMenuClassName="overflow-auto w-100"
          dropdownMenuStyle={{ maxHeight: '30vh' }}
          onChange={(value) => {
            setSelectedChargeStation(null);
            setDraftFilter({
              ...draftFilter,
              managedBy: value,
              stationId: '',
            });
          }}
          isDropdownForm={true}
        />
      </div>
      <div className="col-12 pb-2 p-0">
        {UIHelper.buildFormLabel('Tên trạm sạc')}
        {dropdownChargeStationEl}
      </div>
      {showDateRange && (
        <div className="col-12 p-0">
          <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
            Khoảng thời gian thống kê
          </label>
          <CustomDateRangePicker
            alignRight={true}
            toggleFontWeight="600"
            toggleElementBorderRadius={5}
            initialValue={draftFilter.selectedValue}
            direction={dateDirection}
            onPressSave={(selectedValue, startDate, endDate) => {
              setDraftFilter({
                ...draftFilter,
                from: startDate,
                to: endDate,
                selectedValue: selectedValue,
              });
            }}
          />
        </div>
      )}
    </>
  );
}

export default DashboardChartFilterFields;
